export default function PHP_hrtime() {
  return (
    <div>
      <h1>PHP_hrtime</h1>
    </div>
  );
}
